export default __webpack_public_path__ + "static/media/inventorycalcimgnew.c88dd36c.png";